import { css } from 'lit';

export const nsInputStyles = css`
  wa-input,
  wa-select {
    --wa-form-control-height: auto;
    --wa-form-control-border-width: 0;
    --wa-form-control-border-radius: var(--wa-border-radius-pill);
    --wa-form-control-padding-inline: var(--wa-space-xs);
    --wa-form-control-background-color: var(--primary-input-background-color);
    --wa-form-control-value-color: var(--primary-input-text-color);
    --wa-form-control-placeholder-color: var(--primary-input-text-color);
    --wa-form-control-value-font-size: 1em;
    --wa-form-control-value-font-weight: 400;
    --wa-form-control-value-line-height: normal;

    font-size: inherit;
  }

  wa-select {
    --wa-form-control-activated-color: var(--wa-color-brand-fill-loud);
  }

  wa-input::part(base),
  wa-select::part(combobox) {
    padding-block: var(--wa-space-2xs);
  }

  /* The text sits mid-field even when a slotted button is taller than it (the input has its own height) */
  wa-input::part(base) {
    align-items: center;
  }

  wa-input::part(input) {
    caret-color: var(--wa-form-control-value-color);
  }

  wa-input::part(form-control-label),
  wa-select::part(form-control-label) {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  wa-input.secondary {
    --wa-form-control-background-color: var(--ns-theme-grey-dark);
    --wa-form-control-value-color: var(--ns-theme-white);
    --wa-form-control-placeholder-color: var(--ns-theme-white);
  }

  wa-input.onboarding {
    --wa-form-control-background-color: var(--ns-theme-grey-mid);
    --wa-form-control-value-color: var(--secondary-text-color);
    --wa-form-control-placeholder-color: color-mix(in srgb, var(--ns-theme-black) 75%, transparent);
  }

  wa-otp-input {
    --segment-size: 50px;
    --segment-gap: var(--wa-space-xs);
    --segment-border-radius: var(--wa-border-radius-m);
    --wa-form-control-background-color: var(--primary-stat-background-color);
    --wa-form-control-border-color: var(--ns-theme-grey-mid);
    --wa-form-control-border-width: 2px;

    margin: var(--wa-space-xs) auto;
  }

  wa-otp-input::part(label) {
    margin: 0 0 var(--wa-space-2xs);
    color: inherit;
    font-size: 1em;
  }

  wa-otp-input::part(segment) {
    color: var(--primary-text-color);
    font-size: 2em;
  }

  @media (max-width: 576px) {
    wa-input.onboarding {
      --wa-form-control-value-font-size: 12px;
    }
  }
`;
